import { compose, concat, flatten, get, groupBy, map, sortBy, toLower, values, __ } from 'lodash/fp';
import { createSelector } from 'reselect';
import { ApplicationState, Companionship } from '@mews-commander/types';
import { composeProps, createPropsExtender, Selector } from '@mews/framework';
import { Resource } from '@mews-commander/resources';
import { getOrEmptyArray } from '@mews/fp';
import { Reservation } from '@mews-commander/data-access';
import {
    getCompanionships as getCompanionshipsJS,
    getCompanionshipsAccountIdsByReservationIds as getCompanionshipsAccountIdsByReservationIdsJS,
} from '@mews-commander/legacy-entities/src/ducks/companionships';
import { getResourcesByIds } from '@mews-commander/legacy-entities/src/ducks/resources';
import {
    getServiceNonCancelledCheckedReservations,
    getNonCancelledCheckedReservationIds,
} from '../reservationModuleState';
import { mapAssignedResourceIds } from '../utils';
import { formatSpaceTableData } from './utils';

type GetCompanionshipsAccountIdsByReservationIds = Selector<ApplicationState, { reservationIds: string[] }, string[]>;
type GetCompanionships = Selector<ApplicationState, unknown, Record<string, Companionship>>;

// @ts-expect-error $TSFixMeError: Type '(state: any) => Entities<unknown>' is not assignable to type 'GetCompanionships'.
const getKeyedCompanionships: GetCompanionships = getCompanionshipsJS;

const getCompanionships = compose(values, getKeyedCompanionships);

const getCompanionshipsAccountIdsByReservationIds: GetCompanionshipsAccountIdsByReservationIds =
    getCompanionshipsAccountIdsByReservationIdsJS;

export const getSelectedReservationsCompanionIds = composeProps(
    getCompanionshipsAccountIdsByReservationIds,
    createPropsExtender('reservationIds', getNonCancelledCheckedReservationIds)
);

const getServiceReservationsAssignedResourceIds = createSelector(
    getServiceNonCancelledCheckedReservations,
    mapAssignedResourceIds
);

const getServiceSortedResourceIds = createSelector(
    composeProps(
        getResourcesByIds,
        createPropsExtender<
            ApplicationState,
            { enterpriseId: string; scope: string; serviceId: string },
            string[],
            { ids: string[] }
        >('ids', getServiceReservationsAssignedResourceIds)
    ),
    compose(map('id'), sortBy<Resource>(compose(toLower, get('name'))))
);

const getServiceGroupedReservations = createSelector(
    getServiceNonCancelledCheckedReservations,
    groupBy<Reservation>('assignedResourceId')
);

export const getServiceNonCancelledSortedReservations = createSelector(
    getServiceSortedResourceIds,
    getServiceGroupedReservations,
    (sortedResourceIds, groupedReservations) =>
        compose(
            concat(__, getOrEmptyArray('null', groupedReservations)),
            flatten,
            map<string, Reservation[]>((id) => groupedReservations[id])
        )(sortedResourceIds)
);

export const getServiceResourceTableRows = createSelector(
    getCompanionships,
    getServiceNonCancelledSortedReservations,
    formatSpaceTableData
);
